<template>
  <div class="news">
    <div class="module">
      <div class="title"></div>
      <div class="content">
        <div class="left">
          <div class="swiper" id="imageSwiper">
            <div class="swiper-wrapper">
              <div
                v-for="(image, key) in imageList"
                :key="key"
                class="swiper-slide"
              >
                <img :src="image" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="right">
          <div class="tab-title">
            <div
              v-for="(name, key) in tabTitleList"
              :key="key"
              :class="getTabClass(name)"
              @click="changeTab(name)"
            ></div>
          </div>
          <div class="tab-content">
            <ul>
              <li
                v-for="(item, key) in tabContentList[tab]"
                :key="key"
                class="item"
              >
                <div class="dot"></div>
                <div class="title" @click="openDetailPage(item.id)">{{ item.title }}</div>
                <div class="time">{{ item.time }}</div>
              </li>
            </ul>
          </div>
          <div class="btn-more" @click="openListPage"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.mjs'
import 'swiper/swiper-bundle.css'

import { getNewsList } from '@/api/system.api.js'

export default {
  props: {
    imageList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      swiper: undefined,
      tab: 'latest',
      tabTitleList: ['latest', 'news', 'tips', 'activity'],
      tabContentList: {}
    }
  },
  watch: {
    imageList: function (val) {
      this.initSwiper()
    }
  },
  async created() {
    await this.getNewsList()
  },
  methods: {
    // 初始化轮播图
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('#imageSwiper', {
          direction: 'horizontal',
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'swiper-pagination__btn',
            bulletActiveClass: 'swiper-pagination--active',
            clickable: true,
            renderBullet: function (index, className) {
              return '<div class="' + className + '"></div>'
            }
          },
        })
      })
    },
    // 获取tab标题
    getTabClass(name) {
      return 'item ' + name + (name === this.tab ? ' active' : '')
    },
    // 切换tab
    changeTab(name) {
      this.tab = name
    },
    async getNewsList() {
      const latestReq = this.getNewsListByType('last')
      const newsReq = this.getNewsListByType('news')
      const tipsReq = this.getNewsListByType('strategy')
      const activityReq = this.getNewsListByType('activity')
      Promise.all([latestReq, newsReq, tipsReq, activityReq])
        .then(([latestList, newsList, tipsList, activityList]) => {
          this.tabContentList = {
            "latest": latestList,
            "news": newsList,
            "tips": tipsList,
            "activity": activityList,
          }
        })
        .catch((err) => {

        })
    },
    async getNewsListByType(type) {
      return await getNewsList({
        page: 1,
        limit: 7,
      }, type)
        .then((res) => {
          let list = []
          for (let i = 0; i < res.list.length; i++) {
            list.push({
              id: res.list[i].id,
              tag: res.list[i].tag,
              title: res.list[i].title,
              time: new Date(res.list[i].createtime * 1000).toLocaleDateString('zh-cn'),
              description: res.list[i].desc,
            })
          }

          return list
        })
        .catch(() => {
          return []
        })
    },
    openDetailPage(id) {
      this.$router.push({ name: 'Detail', query: { id: id } })
    },
    openListPage() {
      this.$router.push({ name: 'List' })
    },
  }
}
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  height: 1030px;
  background: url('~@/assets/img/bg_module1.jpg') no-repeat;
  background-position: center;
}

.module {
  padding-top: 74px;
}

.content {
  position: relative;
  margin: 49px auto 0;
  width: 1354px;
  height: 530px;
  background: url('~@/assets/img/bg_news.png') no-repeat;

  .left {
    position: absolute;
    top: 48px;
    left: 27px;
    width: 720px;
    height: 423px;
    background: url('~@/assets/img/bg_swiper.png') no-repeat;

    .swiper {
      margin: 19px 0 0 20px;
      width: 681px;
      height: 428px;

      .swiper-slide {
        ::v-deep img {
          width: 681px;
          height: 383px;
        }
      }

      .swiper-pagination {
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;

        ::v-deep .swiper-pagination__btn {
          display: block;
          margin: 0 7.5px;
          width: 28px;
          height: 25px;
          background: url('~@/assets/img/news_swiper.png') no-repeat;
          background-position: 0 0;
          cursor: pointer;
        }

        ::v-deep .swiper-pagination--active {
          background-position: -28px 0;
        }
      }
    }
  }

  .right {
    position: absolute;
    right: 0;

    .tab-title {
      display: flex;
      width: 638px;
      height: 77px;

      .item {
        cursor: pointer;
        background: url('~@/assets/img/news_title.png') no-repeat;
      }

      .latest {
        width: 204px;
        height: 77px;
        background-position: 0 0;
        &.active, &:hover {
          background-position: 0 -77px;
        }
      }

      .news {
        width: 144px;
        height: 77px;
        background-position: 0 -154px;
        &.active, &:hover {
          background-position: -144px -154px;
        }
      }

      .tips {
        width: 144px;
        height: 77px;
        background-position: 0 -231px;
        &.active, &:hover {
          background-position: -144px -231px;
        } 
      }

      .activity {
        width: 146px;
        height: 77px;
        background-position: -204px 0;
        &.active, &:hover {
          background-position: -204px -77px;
        }
      }
    }

    .tab-content {
      margin: 31px 0 0 68px;
      padding: 10px 0 0 25px;
      width: 536px;
      height: 370px;

      ul {
        width: 491px;
        height: 343px;
        overflow: hidden;
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 0 8px;
        font-size: 18px;
        color: #dededa;
        border-bottom: 1px solid #dededa;

        .dot {
          margin-top: 2px;
          width: 14px;
          height: 13px;
          background: url('~@/assets/img/list_dot.png') no-repeat;
        }

        .title {
          flex: 1;
          margin-left: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }

        .time {
          width: 134px;
          text-align: right;
        }
      }
    }

    .btn-more {
      position: absolute;
      bottom: -40px;
      right: 34px;
      width: 77px;
      height: 27px;
      background: url('~@/assets/img/btn_more.png') no-repeat;
      cursor: pointer;
    }
  }
}
</style>